

import IssueDetail from './issueDetailDom.js'

import ManageIssue from './manageIssue.js'
import $jsonp from './../../../common/ajax.js'


var page = function(commonType){
	var page = null;
	// 存储埋点的数据
	window.trackStorage = [];
	if(commonType==11&&window.commercial.legokey=='nodata'){
		page = null;
	}else if(window.commercial&&(commonType==9||commonType==10||commonType==11)){
  		window.commercial_issue = page  = new IssueDetail();
  		
  		if(commonType==9){
  			page = getHuiDu(page);
  		}else if(commonType == 10 && (window.commercial.local==0||window.commercial.cateid==0)){
  			page = null;
  		} else if(commonType == 10) {
			// 引入优惠券的css和js
			addCss('//c.58cdn.com.cn/crop/ecom/pc/coupon/css/coupon.css?v=' + (new Date()).getTime());
			addJs('//j1.58cdn.com.cn/crop/ecom/pc/coupon/js/coupon.js?v=' + (new Date()).getTime());
  		}

  		// 加载埋点的js
  		if(!window.clickLog || typeof window.clickLog !=="function") {
  			// 埋点js onload方法
  			function fn(){
				for(var i = 0; i < window.trackStorage.length; i++){
					window.commercial_issue.trackClick(window.trackStorage[i]);
				}
			}
  			addJs('//tracklog.58.com/referrer4.js?v=0', fn)
  		}
  	}else{
  		window.commercial_massage = page  = new ManageIssue();
    }
    // console.log(page)
    return page;
}
// 在页面中添加CSS
function addCss(url) {
	var cssNode = document.createElement("link");
	cssNode.setAttribute("rel", "stylesheet");
	cssNode.setAttribute("href", url); 
	document.getElementsByTagName("head")[0].appendChild(cssNode);
}
// 在页面中添加JS
function addJs(url, callBack) {
	var jsNode = document.createElement("script");
	jsNode.setAttribute("type", "text/javascript"); 
	jsNode.setAttribute("src", url); 
	document.getElementsByTagName("body")[0].appendChild(jsNode);
	if(callBack) {
		jsNode.onload = callBack;
	}
}

function getHuiDu(callBack){
	return {
		init:function(){
			$jsonp("//infotophttpapi.58.com/state/get",  
		        {entityType:window.commercial.entityType,infoIds:(window.commercial.entityidlist+"").replace(/,/g,"|"),productIds:100,isExisted:1,isAvailabe:1},
		        function(res){  
		            if(res.errorcode==0&&res.code==200&&res.data[window.commercial.entityidlist+""][100].availabe){
						callBack.init();
		            }
		        }); 
		}
	}
} 

export default page